import styled from 'styled-components';
import { device } from '../../../utils/responsive_utilities';
import { deepCoveDark, mintGreen, orange, white } from '../../loggedout/shared-styles/Colors';
import FontGraphie from '../../loggedout/shared-styles/graphieFont';
import { DisplacementTransition } from '../../loggedout/shared-styles/transitions';
import { Container } from '../styles/shared-styles';
import { moveElementHorizontally, moveElementVertically } from "../../common/animations/animation-components";

export const ContainerWrapper = styled(Container)`
  display: flex;
  flex-direction: column;
`

export const LoadThrough = styled.div`
  margin: auto;
  ${FontGraphie(2.4, 1, 7)}
  width: 45%;
  text-align: center;
  color: ${white};

  transition: all ease-in-out 0.7s;
  transform: translateY(
    ${(props) => {
      return (props.state === "entering" || props.state === "entered") ? '0' : '-15rem';
    }
  }
  );
  opacity: ${({ state }) => state === "entering" || state === "entered" ? 1 : 0};
  p:nth-of-type(2){
    margin-top: 1.6rem;
  }
`

export const InfoBox = styled.div`
  width: 64rem;
  height: 27.5rem;
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  box-sizing: border-box;
  margin: 4.5rem auto;  
  color: ${white};
`

export const LpImage = styled.div`
  width: 23.2rem;
  height: 27.5rem;
  >img{
    width: 100%;
    height: 100%;
    border-radius: 1.6rem;
    animation : ${moveElementHorizontally({ x1: -2, x2: 0 })} 2s ease;
  }
`

export const LpContent = styled.div`
  width: 38rem;
  margin: auto 0;
  box-sizing: border-box;
`

export const LpHeading = styled.div`
  ${FontGraphie(2.8, 1.2, 7)}
  text-align: left;
  animation : ${moveElementVertically({ y1: -3, y2: 0 })} 3s ease;
`
export const LpHelpSection = styled.div`
  margin-top: 1.6rem;
`
export const LabelText = styled.p`
  ${FontGraphie(1.4, 1.7, 7)}
  color: ${white};
  text-align: left;
  margin-top: 2.4rem;
`

export const LpTagsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-between;
  animation : ${moveElementVertically({ y1: -3, y2: 0 })} 3s ease;
`

export const LPTag = styled.span`
  ${FontGraphie(1.4, 1.4, 7)}
  background: ${props => props.fillColor ? props.fillColor : "#797CDB"};
  border-radius: 0.4rem;
  padding: 0.4rem 1.2rem;
  margin-top: 0.8rem;
  text-transform: uppercase;
`

export const AboutSection = styled.div`
  width: 100%;
  margin-top: 1.6rem;
  > p{
    ${FontGraphie(2, 1.4, 6)}
    text-align: left;
  }
`

export const EdgeIcon = styled.div`
  position: absolute;
  width: 7.5rem;
  height: 8.7rem;
  top: -4.5rem;
  left: -5rem;
  >img{
    width: 100%;
    height: 100%;
  }
`

export const CTAContainer = styled.div`
  >button{
    background: ${white};
    border-radius: 3.2rem;
    padding: 1.6rem 8.7rem;
    ${FontGraphie(1.8, 1.2, 6)}
    color: #090A4A;
    margin-bottom: 4.8rem;
    border: none;
  }
`

export const BottomText = styled.p`
  ${FontGraphie(1.6, 1.2, 4)}
  color: ${white};
  text-align: center;
`